<div class="user-info">
  <button type="button" (click)="showDropdown.set(!showDropdown())">
    <mars-avatar
      [fullName]="authService.userData()?.user?.name ?? ''"
      borderRadius="rounded-full" />
  </button>

  @if (showDropdown()) {
    <div
      marsClickOutSide
      (clickOutside)="showDropdown.set(false)"
      class="user-dropdown p-md bg-white border border-neutral-200 rounded-md flex flex-col gap-md">
      <div class="info flex flex-col gap-sm p-sm">
        <div class="user-info flex gap-md">
          <div class="avatar">
            <mars-avatar
              [fullName]="authService.userData()?.user?.name ?? ''"
              borderRadius="rounded-full" />
          </div>

          <div class="text-info">
            <p
              class="break-all font-semibold mb-xs name text-neutral-900 text-small">
              {{ authService.userData()?.user?.name }}
            </p>
            <p
              class="break-all email font-semibold text-extra-small text-neutral-700">
              {{ authService.userData()?.user?.email }}
            </p>
          </div>
        </div>

        @if (userType) {
          <div class="user-type">
            <mars-badge
              [label]="userType"
              [badgeClass]="
                'text-extra-small font-medium text-white px-sm ' +
                (userType === 'Buyer' ? 'bg-buyer-500' : 'bg-supplier-500')
              " />
          </div>
        }
      </div>

      <button
        type="button"
        [disabled]="isLoggingOut()"
        (click)="userLogout()"
        class="disabled:opacity-20 disabled:cursor-not-allowed">
        <div
          class="logout flex items-center gap-md py-md px-sm border-t border-neutral-200">
          <mars-logout-icon />

          <p class="font-medium text-extra-small text-neutral-900">
            {{ 'user_info_screen_logout_button' | transloco }}
          </p>
        </div>
      </button>
    </div>
  }
</div>
